import * as Yup from "yup";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const EmailFormValidation = (translator) => Yup.object({
  name: Yup.string().min(2).required(translator("contactPage.nameRequired")),
  email: Yup.string()
    .matches(emailRegex, translator("contactPage.emailInvalid"))
    .required(translator("contactPage.emailRequired")),
  phoneNumber: Yup.string()
    .matches(/^[0-9]/, {
      message: translator("contactPage.validNumber"),
      excludeEmptyString: true,
    })
    .required(translator("contactPage.phoneNumberRequired")),
  fieldOfStudy: Yup.string().required(translator("contactPage.fosRequired")),
  subject: Yup.string().required(translator("contactPage.subjectRequired")),
  message: Yup.string().required(translator("contactPage.messageRequired")),
});
